import AbstractRsvpDetailsPageController from './abstract-details-controller';

export default class RsvpDetailsCheckinsPageController extends AbstractRsvpDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/details/checkins-controller.js